import { useAuth0 } from '@auth0/auth0-react';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

/**
 * Login screen — Auth0 Universal Login redirect.
 */
export const Route = createFileRoute('/_public/login')({
  component: LoginPage,
});

function LoginPage() {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const { t } = useTranslation();

  const handleLogin = () => {
    void loginWithRedirect({
      appState: { returnTo: '/dashboard' },
    });
  };

  return (
    <main className="flex min-h-dvh items-center justify-center p-8">
      <div className="max-w-md rounded-lg border border-[var(--color-border)] bg-[var(--color-bg-elevated)] p-8 shadow-sm">
        <div className="mb-4 flex items-center gap-3">
          <img src="/efiszki-logo.png" alt="" className="h-12 w-12" />
          <h1 className="text-2xl font-bold">{t('app.title')}</h1>
        </div>
        <p className="mb-6 text-sm text-[var(--color-text-secondary)]">{t('app.tagline')}</p>
        <button
          type="button"
          onClick={handleLogin}
          disabled={isLoading || isAuthenticated}
          className="w-full rounded-md bg-[var(--color-accent)] px-4 py-2 font-medium text-[var(--color-accent-foreground)] transition hover:bg-[var(--color-accent-hover)] disabled:opacity-50"
        >
          {isLoading ? t('auth.loading') : t('auth.login')}
        </button>
      </div>
    </main>
  );
}
